import moment from 'moment';

export default class DateHelper {

    static MomentNow() : moment.Moment{
        return moment();
    }

    static FormatNow() : string {
        return DateHelper.FormatJsDate(new Date());
    }

    static FormatDateTime(date: moment.Moment): string {
        const minDate: moment.Moment = moment.utc('0001-01-01');

        if (date === null || minDate.year() === date.year()) {
            return '';
        }

        const jsDate = date.toDate();

        return DateHelper.FormatJsDate(jsDate);
    }

    static FormatDate(date: moment.Moment | null | undefined): string {

        return this.isValidDate(date) && date ? date.format('L') : '';
    }

    static FormatJsDate(jsDate: Date): string {
        const date = jsDate.toLocaleDateString();

        const regex =/.*\/1$/ 
        if(regex.test(date)){ //To handle native default dates
            return '';
        }

        const time = jsDate.toLocaleTimeString();
        return `${date} ${time}`;
    }

    static FormatNotifcationDate(date : moment.Moment) : string {
        let formattedDate = date.format('ll');

        const days = moment().diff(date, 'days');

        if(days >= 0 && days <= 30){
            formattedDate = moment(date).fromNow();
        } 
        return formattedDate; 
    }

    private static isValidDate(date : moment.Moment | null | undefined) : boolean {
        return <boolean>(date && date.year() > 1900);
    }
}